var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slider",class:{ 'team-root-loading' : _vm.teamRootLoading }},[_c('div',{staticClass:"line"}),_c('div',{staticClass:"subline inc"}),_c('div',{staticClass:"subline dec"})])}
var staticRenderFns = []

export { render, staticRenderFns }